import React from 'react'
import { connect } from 'react-redux'
import UserActions from '../../Redux/UserRedux'
import { currentBranch } from '../../Utils/PrivilegeUtils'
import { includes } from 'lodash'

class DownloadUserList extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY'
    this.type = [
      { value: '', label: 'All' },
      { value: 'passpod', label: 'Passpod' },
      { value: 'travypass', label: 'Travypass', restriction: 'PH' }
    ].filter((option) => { return (!includes(option.restriction, currentBranch())) })
    this.state = {
      filter: {
        type: ''
      }
    }
  }

  _typeChange = (args) => {
    let val = args.target.value
    let filter = { ...this.state.filter }
    filter.type = val
    this.setState({ filter })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = { ...this.state.filter }
    this.props.download(data)
    this.props.closeModal()
  }

  render () {
    const { user } = this.props
    return (
      <form onSubmit={(event) => this._submit(event)} className='section' style={{ width: '20vw' }}>
        <header className='title-block'>
          <h4 className='title mr-auto'>
            Download User List
            {
              (user.fetching || user.processing) &&
              <div className='badge badge-info ml-2'>{user.fetching ? 'Loading' : 'Processing'} ...</div>
            }
          </h4>
        </header>
        <div className='form-group'>
          <label className='control-label mr-2'>Source</label>
          <select className='form-control' value={this.state.filter.type} onChange={(event) => this._typeChange(event)}>
            {
              this.type.map((item, i) => (
                <option key={i} value={item.value}>{item.label}</option>
              ))
            }
          </select>
        </div>
        <div className='text-right'>
          <button type='button' className='btn btn-lg btn-secondary mr-2' onClick={() => this.props.closeModal()}>Close</button>
          <button type='submit' className='btn btn-lg btn-primary'>Download</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  user: state.user
})

const dispatchToProps = (dispatch) => ({
  download: (data) => dispatch(UserActions.userListRequest(data))
})

export default connect(stateToProps, dispatchToProps)(DownloadUserList)



// WEBPACK FOOTER //
// ./src/Containers/User/DownloadUserList.js